export default "__VITE_ASSET__CVQKXK47__"